import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="policy-container max-w-4xl mx-auto py-12 px-4 md:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Shipping & Delivery Policy</h1>
      <p className="text-lg text-gray-700 mb-8 leading-relaxed">
        At <strong>Cycle Services</strong>, we ensure your bicycles, parts, accessories, and repair tools are delivered 
        safely and efficiently. Please review our shipping policy for bicycles and related products.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Order Processing</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Orders are processed within <strong>1–2 business days</strong> after payment confirmation. 
        cycle assembly orders may take an extra day for quality checks. Weekend/holiday orders process next working day.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Delivery Areas</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        We ship across India. Local pickup available from our Mumbai service centers for faster delivery and free collection. 
        Unserviceable areas will be notified with full refund options.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Estimated Delivery Time</h2>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li><strong>Local Pickup (Mumbai):</strong> Ready within 24 hours.</li>
        <li><strong>Metro Cities:</strong> 2–4 business days.</li>
        <li><strong>Tier 2/3 Cities:</strong> 4–6 business days.</li>
        <li><strong>Remote Areas:</strong> 6–10 business days.</li>
      </ul>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        cycle deliveries include professional packaging to prevent frame/paint damage during transit.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Shipping Charges & Payment Options</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        Charges based on cycle size/weight, parts volume, and pincode. Free local delivery/pickup in Mumbai. 
        Volumetric weight for complete cycles.
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li><strong>Online Payment:</strong> Razorpay/PhonePe (secure checkout).</li>
        <li><strong>Cash on Delivery (COD):</strong> Pay at delivery (availability by pincode).</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Delivery Date Selection</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Choose your preferred delivery date at checkout. We'll confirm availability and send reminders. 
        Local pickups available same/next day.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Tracking Your Order</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Dispatch tracking ID sent via email/SMS/WhatsApp. Track via courier portal or contact our team for status updates.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Bicycle-Specific Handling</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        cycles shipped partially assembled (pedals/wheels removed) with tools/instructions. 
        Fragile parts (carbon frames) double-boxed.
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Assembly service available at delivery (extra charge).</li>
        <li>Repair tools/parts in protective padding.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Delays & Exceptions</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Delays possible due to weather, road conditions, or high-volume seasons. We'll notify you proactively.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Damaged or Lost Shipments</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Report damage (frame dents, scratches) within 48 hours with photos. Free replacement or refund after inspection.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Address Changes</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Changes accepted pre-dispatch. Post-dispatch rerouting may incur fees.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contact Us</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        For shipping queries:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
        <li><strong>Phone:</strong> 8082080816</li>
        <li><strong>Email:</strong> cyclerental@gmail.com</li>
        <li><strong>Address:</strong> Mumbai, MH - 400101, India</li>
      </ul>
    </div>
  );
};

export default ShippingPolicy;

